import { useState } from "react";

const ImageWithSkeleton = ({ src, alt, className, style, classNameInIMage, noRounded = false, isBlog }) => {
    const [loading, setLoading] = useState(true);
    return (
        <div className={`relative ${className}`} style={style}>
            {loading && (
                <div
                    className={`absolute inset-0 bg-gray-200 animate-pulse ${noRounded ? '' : 'rounded-lg'}`}
                    style={style}
                ></div>
            )}
            <img
                src={src}
                alt={alt}
                style={{ ...style, opacity: loading ? 0 : 1, transition: "opacity 0.3s" }}
                onLoad={() => setLoading(false)}
                className={classNameInIMage}
            />
        </div>
    );
};

export default ImageWithSkeleton;
